import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { createContext, useContext, useState } from 'react';
import { useMemoizedFn } from 'ahooks';
export var WecomAppAuthContext = createContext(null);
export var RcWecomAppAuth = function RcWecomAppAuth(props) {
  var children = props.children,
    corpId = props.corpId,
    userId = props.userId;
  var _useState = useState({
      corpId: corpId,
      userId: userId
    }),
    _useState2 = _slicedToArray(_useState, 2),
    authState = _useState2[0],
    setAuthState = _useState2[1];
  var updateAuthState = useMemoizedFn(function (part) {
    setAuthState(function (prev) {
      return _objectSpread(_objectSpread({}, prev), part);
    });
  });
  return React.createElement(WecomAppAuthContext.Provider, {
    value: _objectSpread(_objectSpread({}, authState), {}, {
      updateAuthState: updateAuthState
    })
  }, children);
};
export var useWecomAppAuth = function useWecomAppAuth() {
  var value = useContext(WecomAppAuthContext);
  if (!value) {
    throw new Error('useWecomAppAuth must under withWecomAppAuth');
  }
  return value;
};